module.exports = __webpack_public_path__ + "static/media/share.b2a30bf8.svg";